import { BreadcrumbComponent, CIAppliedFilter, CIAppliedListFilter, SearchInput } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';

import { debounce } from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AssociationListFilter } from '../../../../_components/association-filter/AssociationListFilter';
import { statusList } from '../../../../_components/filter/Filter';
import { DEBOUNCE_DELAY, FILTER_TYPE, SORT_TYPE, allStatusList } from '../../../../constants';
import { IActiveJourney } from '../../../../store/actions/types/sources/GetAllJourneys';
import AssociationHeader from '../../../events/events-associations/association-header/AssociationHeader';
import JourneyAssociationList from '../journey-association-list/JourneyAssociationList';
import classes from './ServiceAssociationWrapper.module.scss';

const ServiceAssociationWrapper = () => {
  const { t: translate } = useTranslation();
  const location = useLocation();
  const [queryParams, setQueryParams] = useState<{ [key: string]: string; }>({
    page: String(0),
    item: String(10),
    serviceName: '',
    status: '',
    sort: SORT_TYPE.UPDATED_TIMESTAMP,
    sortType: SORT_TYPE.DESCENDING });
  const { associationServiceName, associationVersion, associationStatus } = location.state;
  const [journeys, setJourney] = useState<IActiveJourney>({ totalJourneysCount: 0, journeyList: [] });
  const [searchTemp, setSearchTemp] = useState<string>('');
  const allStatusMap: { [key: string]: string } = {};
  allStatusList.forEach((s) => { allStatusMap[s.value] = s.label; });
  const filterData = {
    searchText: queryParams?.searchText,
    status: queryParams?.status !== '' ? queryParams?.status : queryParams?.status || statusList.toString(),
    pageNo: 0,
    item: journeys.totalJourneysCount,
    searchTitle: 'service_list_component.lbl_service_name_search',
    sort: queryParams?.sort !== '' ? queryParams?.sort : SORT_TYPE.UPDATED_TIMESTAMP_DESC
  };

  const debounceHandler = useCallback(debounce((value: string) => {
    const queryParam = { ...queryParams,
      searchText: value,
      status: queryParams?.status,
      sort: SORT_TYPE.UPDATED_TIMESTAMP,
      sortType: SORT_TYPE.DESCENDING,
      page: '0'
    };
    setQueryParams(queryParam);
  }, DEBOUNCE_DELAY), [searchTemp]);

  const searchHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTemp((event.target.value).trim());
    debounceHandler((event.target.value).trim());
  };
  const appliedFilterData: CIAppliedFilter[] = useMemo(() => {
    const data: CIAppliedFilter[] = [];
    const filterStatusList: string[] = filterData?.status?.split(',');
    if (!filterData) {
      return [];
    }
    if (filterStatusList?.length > 0 && filterStatusList?.length < allStatusList.length) {
      filterStatusList?.forEach((f: string) => data.push({ text: allStatusMap[f], type: FILTER_TYPE.STATUS, value: f }));
    }
    return data;
  }, [filterData]);

  const appliedFilterChangeHandler = (filters: CIAppliedFilter[]) => {
    const statusList: string[] = [];
    filters.forEach((f) => {
       statusList.push(f.value);
    });
    const queryParam = {
      searchText: queryParams?.searchText ?? '',
      status: statusList?.join(',') ?? '',
    };
    setQueryParams((pre) => ({
      ...pre,
      ...queryParam
    }));
  };

  const onJourneyListSuccess = (journeys: IActiveJourney) => {
    setJourney(journeys);
  };

  return (
    <div className={classes['service-association-wrapper']} id="association-container">
      <BreadcrumbComponent />
      <AssociationHeader
        header={associationServiceName}
        subHeader={`${translate('event_associations.header_text_associations')}`}
        status={associationStatus}
        description={`${translate('event_associations.service_association_description')}`}
        version={associationVersion}
        containerHeaderId="association-header-container"
        containerId="association-container"
      />
      <div className={classes.filters}>
        <div className={classes['search-filter-div']}>
          <AssociationListFilter
            queryParams={queryParams}
            setQueryParams={setQueryParams}
          />
          <div className={classes.search}>
            <SearchInput
              label="search"
              type="search"
              placeholder={String(translate('journey_list_component.lbl_search'))}
              onChange={searchHandler}
              data-testid="filterSearchInput"
              value={searchTemp}
            />

          </div>
        </div>
        <CIAppliedListFilter className={classes['applied-filters']} totalRecords={journeys.totalJourneysCount} appliedFilters={appliedFilterData} onFilterChange={appliedFilterChangeHandler} showResetFiltersButton={appliedFilterData.length > 0} />
      </div>
      <JourneyAssociationList
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        onJourneyListSuccess={onJourneyListSuccess}
      />
    </div>
  );
};

export default ServiceAssociationWrapper;
